<div class="one-column-page">
  <div class="one-column-content">
    <h1>{{getScenarioHeader()}}</h1>
    <p class="center section-spacing"
       anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.DESCRIPTION"
    ></p>
    <p class="center section-spacing"
       anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.BASELINE_RESULTS_MESSAGE"
    ></p>

    <div class="section-spacing">
      <div style="width: 100%;">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.SCENARIO_NAME" ></mat-label>
          <input id="scenario-name_input"
                 matInput
                 type="text"
                 [(ngModel)]="scenario.name"
                 name="scenarioName"
                 noWhitespace
                 trimWhitespace
                 required
                 (change)="setUnsavedChanges()"
          >
        </mat-form-field>
      </div>
    </div>

    <!-- input selection dropdown-->

    <div class="flex-container">
      <div class="flex-box no-padding max-width">
        <mat-form-field floatLabel="never"
                        class="anessa-dropdown">
          <mat-select multiple
                      id="scenario-input_select"
                      [placeholder]="'SCENARIO_COMPARISON.SCENARIO_MODIFY.INPUTS_PLACEHOLDER' | anessaTranslation: undefined"
                      [(ngModel)]="scenario.inputs"
                      (ngModelChange)="onSelectedInputsChange()"
                      panelClass="anessa-dropdown-panel">
            <ngx-mat-select-search [placeholderLabel]="'RESULTS.GENERAL.SEARCH' | anessaTranslation: undefined"
                                   [noEntriesFoundLabel]="'SCENARIO_COMPARISON.SCENARIO_MODIFY.NO_INPUTS_FOUND' | anessaTranslation: undefined"
                                   class="clear-search"
                                   [(ngModel)]="inputFilter"
                                   (ngModelChange)="filterInputs()">
              <i class="material-icons" ngxMatSelectSearchClear>
                delete
              </i>
            </ngx-mat-select-search>
            <mat-checkbox
              class="mat-option mat-option-multi select-all-opt"
              color="primary"
              (change)="onInputsCheckAll($event)"
              [checked]="allInputsSelected()"
              [indeterminate]="isCheckAllIndeterminate()"
              #inputsCheckbox>{{
                inputsCheckbox.checked ?
                  ('RESULTS.GENERAL.DESELECT_ALL' | anessaTranslation: undefined) :
                  ('RESULTS.GENERAL.SELECT_ALL' | anessaTranslation: undefined)
              }}
            </mat-checkbox>
            <div *ngFor="let input of filteredInputsData"
                 [matTooltip]="tooltips[input.uuid] | anessaTranslation: undefined"
                 [matTooltipPosition]="'left'"
            >
              <mat-option [value]="input"
                          [disabled]="disabled[input.uuid]"
                          (onSelectionChange)="onInputSelect($event)"
              >
                {{ inputTranslations[input.id] }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <form #sensForm="ngForm"
          class="bottom-spacing">
      <div >
        <table mat-table [dataSource]="scenario.inputs" class="sens-table">

          <!-- "include" checkbox column -->
          <ng-container matColumnDef="include">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="rowsCheckAll($event)"
                [checked]="allRowsSelected()"
              ></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox
                [(ngModel)]="selectedTableRows[element.uuid]"
                [ngModelOptions]="{ standalone: true }"
                (change)="onRowSelected($event, element.uuid)"></mat-checkbox>
            </td>
          </ng-container>

          <!-- "variable" input name column -->
          <ng-container matColumnDef="variables">
            <th mat-header-cell
                *matHeaderCellDef
                anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.TABLE_HEADERS.VARIABLES"
            ></th>
            <td mat-cell *matCellDef="let element">
              <div class="input-table-name-cell-container">
                <ng-container *ngIf="invalidInputs?.length > 0 || affectedInputs?.length > 0">
                  @if (invalidInputs?.includes(element.id)) {
                    <mat-icon class="error-icon"
                              [matTooltip]="'SCENARIO_COMPARISON.SCENARIO_MODIFY.INVALID_INPUTS_TOOLTIP' | anessaTranslation: undefined"
                    >error</mat-icon>
                  } @else if (affectedInputs?.includes(element.id)) {
                    <mat-icon class="warning-icon"
                              [matTooltip]="'SCENARIO_COMPARISON.SCENARIO_MODIFY.AFFECTED_INPUTS_TOOLTIP' | anessaTranslation: undefined"
                    >warning</mat-icon>
                  } @else {
                    <mat-icon style="visibility: hidden">warning</mat-icon>
                  }
                </ng-container>

                {{(element.id ? (element.nameElements | anessaTranslation: undefined) :
                ('SCENARIO_COMPARISON.SCENARIO_MODIFY.NO_INPUTS_SELECTED' | anessaTranslation: undefined))
                }}
              </div>

            </td>
          </ng-container>

          <!-- scenario value input column -->
          <ng-container matColumnDef="scenarioValue">
            <th mat-header-cell
                *matHeaderCellDef
                anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.TABLE_HEADERS.SCENARIO_VALUE"
            ></th>
            <td mat-cell *matCellDef="let element">
              <mat-form-field>
                <!-- make sure the name/id are not changed without also changing the functions -->
                <!-- that rely on them -->
                <input type="number"
                       matInput
                       appScenarioItemValidator
                       [scenarioValueErrors]="scenarioValueErrorHints"
                       [uuid]="element.uuid"
                       [(ngModel)]="element.scenarioValue"
                       [disabled]="(!element.id)"
                       [placeholder]="(element.id ? ('SCENARIO_COMPARISON.SCENARIO_MODIFY.ENTER_VALUE' | anessaTranslation: undefined) :
                        ('SCENARIO_COMPARISON.SCENARIO_MODIFY.N_A' | anessaTranslation: undefined))"
                       [name]="element.id + '-scenario-value'"
                       [id]="element.id + '-scenario-value'"
                       (input)="onInputChange(element)"
                >
                <mat-error>
                  <div *ngFor="let error of getErrorKeysForElement(element)"
                       class="red-text"
                       [anessaTranslation]="errorsHintsDict[error]"
                  ></div>
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- baseline value column -->
          <ng-container matColumnDef="value">
            <th mat-header-cell
                *matHeaderCellDef
                anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.TABLE_HEADERS.VALUE"
            ></th>
            <td mat-cell *matCellDef="let element"> {{
                (checkIfNum(element.baselineValue) ? element.baselineValue :
                  ('SCENARIO_COMPARISON.SCENARIO_MODIFY.N_A' | anessaTranslation: undefined))
              }}
            </td>
          </ng-container>

          <!-- unit column -->
          <ng-container matColumnDef="unit">
            <th mat-header-cell
                *matHeaderCellDef
                anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.TABLE_HEADERS.UNIT"
            ></th>
            <td mat-cell *matCellDef="let element">
              <div [innerHTML]="(element.unit ? (processUnitName(element.unit)) :
            ('SCENARIO_COMPARISON.SCENARIO_MODIFY.N_A' | anessaTranslation: undefined))"></div>
            </td>
          </ng-container>

          <tr *matNoDataRow>
            <td class="no-data-row"
                [attr.colspan]="tableHeaders.length"
                anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.TABLE.NO_DATA_ROW"
            ></td>
          </tr>

          <tr mat-header-row *matHeaderRowDef="tableHeaders"></tr>
          <tr mat-row *matRowDef="let row; columns: tableHeaders;"></tr>
        </table>
      </div>

      <div>
        <button
          id="scenario-modify-remove-selected-input-button"
          mat-button
          class="remove-selected-btn btn-red"
          type="button"
          (click)="onRemoveSelectedInputsClick()"
          [disabled]="scenario?.inputs?.length <= 0"
        >{{getRemoveInputsBtnText() | anessaTranslation: undefined}}</button>
      </div>

      <!-- error summary -->
      <div *ngIf="sensForm['form'].invalid || formErrors.length > 0">
        <br><br>
        <ul>
          <p *ngFor="let errorName of formErrors"
             class="red-text"
             [anessaTranslation]="errorsSummaryDict[errorName]"
          ></p>
        </ul>
      </div>


      <!-- percent change input container -->

      <div class="section-spacing border-shadow apply-section">
        <div class="flex-container">
          <div class="flex-box input-container">
            <div class="flex-container flex-align-item-center">
              <p anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.PERCENT_CHANGE"></p>
              <i class="material-icons apply-icon"
                 [matTooltip]="'SCENARIO_COMPARISON.SCENARIO_MODIFY.PERCENT_CHANGE_HELP' | anessaTranslation: undefined"
              >help</i>
            </div>
            <mat-form-field>
              <input id="scenario-input-percentChange_input"
                     type="number"
                     matInput
                     [(ngModel)]="changePercent.value"
                     name="changePercent"
                     (input)="checkPercentChangeInput(changePercent)"
              >
              <mat-error>
                <div *ngFor="let error of changePercent.errors"
                     class="red-text"
                     [anessaTranslation]="errorsHintsDict[error]"
                ></div>
              </mat-error>
              <div matSuffix class="edit-caption">
                %
              </div>
            </mat-form-field>
          </div>
        </div>
        <div>
          <button
            id="scenario-input-applyToAll_button"
            mat-button
            type="button"
            class="apply-button"
            (click)="applyPercentChange()"
            [disabled]="changePercent.errors.length > 0"
          >{{
              (numOfSelectedRows() > 0) ? ('SCENARIO_COMPARISON.SCENARIO_MODIFY.APPLY_TO_SELECTED' | anessaTranslation: undefined) :
                ('SCENARIO_COMPARISON.SCENARIO_MODIFY.APPLY_TO_ALL' | anessaTranslation: undefined)
            }}
          </button>
        </div>
      </div>

      <!-- Biogas share data sliders -->
      <div class="biogas-slider-container section-spacing border-shadow">
        @if (biogasSlidersAvailable) {
          <div>
            <mat-slide-toggle
              [id]="getId(scenario.name, '-biogas_toggle')"
              [(ngModel)]="scenario.enableProductSliders"
              (ngModelChange)="onEnableBiogasSliderChange($event)"
              [ngModelOptions]="{ standalone: true }"
            >{{'SCENARIO_COMPARISON.ENTRY.INCLUDE_BIOGAS' | anessaTranslation: undefined}}</mat-slide-toggle>
          </div>
          <div *ngIf="scenario.enableProductSliders" class="item">
            <app-percent-slider
              [title]="'SCENARIO_COMPARISON.ENTRY.BIOGAS_SHARE_TITLE' | anessaTranslation: undefined"
              [sliderData]="biogasSliderData"
              (sliderDataChange)="biogasDistributionChanged($event)"></app-percent-slider>
          </div>
        } @else {
          <p anessaTranslation="SCENARIO_COMPARISON.SCENARIO_MODIFY.BIOGAS_SHARE_DATA_UNAVAILABLE"></p>
        }
      </div>


      <!-- save/reset button -->
      <app-save-cancel-buttons
        (saveClick)="onSaveClick()"
        [saveButtonType]="'button'"
        (cancelClick)="onCancelClick()"
        [formValid]="getFormValid()"
        [showSidebarButtons]="false"
      ></app-save-cancel-buttons>


    </form>
  </div>
</div>
